module.exports = __webpack_public_path__ + "assets/shoppingBag-82587c.svg";